import React, { useMemo } from 'react';
import styles from './index.module.scss.js';
import { LiveLoad } from '../../../../feature/lists/LiveLoad/index.js';

const BodyWrapper = ({
  liveLoad,
  isEmpty,
  countRow = 10,
  listMaxHeight,
  listMinHeight,
  children
}) => {
  const maxHeight = useMemo(
    () => listMaxHeight || countRow * 48,
    [listMaxHeight, countRow]
  );
  const minHeight = useMemo(
    () => listMinHeight || countRow * 48,
    [listMaxHeight, countRow]
  );
  if (!liveLoad || isEmpty) return children;
  return /* @__PURE__ */ React.createElement(
    LiveLoad,
    {
      style: {
        maxHeight,
        minHeight
      },
      itemMaxHeight: 48,
      gradient: true,
      gap: 0,
      className: styles.box
    },
    children
  );
};
BodyWrapper.displayName = "BodyWrapper";

export { BodyWrapper };
//# sourceMappingURL=index.js.map
